module.exports = __webpack_public_path__ + "img/md-cloud-download.47419780.svg";